import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule, CurrencyPipe} from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DiscoverComponent } from './discover/discover.component';
import { BehaviorComponent } from './behavior/behavior.component';
import { MarketvalueComponent } from './marketvalue/marketvalue.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactComponent } from './contact/contact.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MainComponent } from './main/main.component';
import { ThousandSuffixesPipe } from './thousand-suff.pipe';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    DiscoverComponent,
    BehaviorComponent,
    MarketvalueComponent,
    AboutusComponent,
    ContactComponent,
    NavbarComponent,
    MainComponent,
    ThousandSuffixesPipe,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
	CommonModule,
	HttpClientModule,
	AppRoutingModule,
	FormsModule,
  ],
  providers: [CurrencyPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
